module.exports = __webpack_public_path__ + "56bf4048992bfcc41e02b8fadde9b0a6.svg";